export interface TileHeader {
  title: string
  icon: string
}

export type MotorProductType =
  | 'ANHAENGER'
  | 'AUTO'
  | 'E_BIKE'
  | 'E_MOPED'
  | 'FALLBACK'
  | 'MOTORRAD'
  | 'OLDTIMER'
  | 'QUAD'
  | 'ROLLER'
  | 'SEASONAL_ANHAENGER'
  | 'SEASONAL_FALLBACK'
  | 'SEASONAL_KFZ'
  | 'SEASONAL_MOTORRAD'
  | 'SEASONAL_QUAD'
  | 'SEASONAL_ROLLER'
  | 'SEASONAL_TRIKE'
  | 'SEASONAL_WOHNMOBIL'
  | 'TECH_INSURANCE'
  | 'TRIKE'
  | 'WOHNMOBIL'

export enum FahrerkreisOptions {
  DEFAULT = 'DEFAULT',
  VN_UEBERWIEGEND_PRIVAT = 'VN_UEBERWIEGEND_PRIVAT',
  VN_UEBERWIEGEND_GESCHAEFTLICH = 'VN_UEBERWIEGEND_GESCHAEFTLICH',
  VN_UND_PARTNER_UEBERWIEGEND_PRIVAT = 'VN_UND_PARTNER_UEBERWIEGEND_PRIVAT',
  VN_UND_ANDERE_UEBERWIEGEND_PRIVAT = 'VN_UND_ANDERE_UEBERWIEGEND_PRIVAT',
  VN_UND_ANDERE_UEBERWIEGEND_GESCHAEFTLICH = 'VN_UND_ANDERE_UEBERWIEGEND_GESCHAEFTLICH'
}
